// 兼容统一投影及已有订单的类型编码，内部记录 ID 不参与展示。
export function agentCommissionTypeLabel(type) {
  return {
    TEAM: '团队佣金',
    SINGLE: '单线佣金',
    ADJUSTMENT: '佣金调整',
    AGENT_TEAM_COMMISSION: '团队佣金',
    AGENT_SINGLE_LINE_COMMISSION: '单线佣金',
    AGENT_COMMISSION_ADJUSTMENT: '佣金调整',
  }[type] || '其他佣金'
}

export function agentRecordStatusLabel(status, tab) {
  const labels = tab === 'settlement'
    ? { 1: '待结算', 2: '结算中', 3: '已结算', 4: '已拒绝' }
    : { 1: '待发放', 2: '处理中', 3: '已发放', 4: '已拒绝' }
  return labels[status] || '状态待确认'
}

export function agentRecordTimeLabel(timestamp) {
  if (!timestamp || !Number.isFinite(Number(timestamp))) return '—'
  const date = new Date(Number(timestamp) * 1000)
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString('zh-CN', { hour12: false })
}
